import React, {useEffect, useState} from 'react'
import {MESSAGE_TYPE_SEXICON} from 'core/constants'
import sexIcons from '../../../assets/sexicons.json'
import Icon from './Icon'

export const SexIcons = ({conversation, areEmojisShown, user}) => {
  const [toggleGallery, setToggleGallery] = useState(true)
  const [toggleHardIcons, setToggleHardIcons] = useState(true)
  const [toggleSoftIcons, setToggleSoftIcons] = useState(false)
  const [userHasSentFreeIcon, setUserHasSentFreeIcon] = useState(false)
  const [hasTriggered, setHasTriggered] = useState(false)
  useEffect(() => {
    user.hasusedfreesexicon && setUserHasSentFreeIcon(true)
  }, [user.hasusedfreesexicon])
  useEffect(() => {
    if (areEmojisShown && !toggleGallery) {
      setToggleGallery(true)
    }
  }, [areEmojisShown])
  const galleryBtnHandler = () => {
    setToggleGallery(!toggleGallery)
    setHasTriggered(true)
  }
  const iconBtnHandler = () => {
    setToggleHardIcons(!toggleHardIcons)
    setToggleSoftIcons(!toggleSoftIcons)
  }
  const onSelectGif = src => {
    setToggleGallery(!toggleGallery)
    conversation.send(src, MESSAGE_TYPE_SEXICON, !userHasSentFreeIcon)
    setUserHasSentFreeIcon(true)
  }
  const shouldApplyClass = index => {
    return index % 5 === 3 || index % 5 === 4
  }
  return (
    <>
      <div className="sex-icon-wrapper">
        <a className="sex-icon-button" onClick={galleryBtnHandler}> <Icon iconName="sexicon"/> </a>
        <div className={`sex-icon-gallery ${toggleGallery ? 'hidden' : ''}`}>
          <p className="recipient-username">Tell {conversation.otherUserProfile.username} what you feel like!<span
            className="close-icon" onClick={galleryBtnHandler}></span></p>
          <div className="sex-icon-hard">
            <div className="sex-icon-header" onClick={iconBtnHandler}><span>Kinky</span> <span
              className={`${!toggleHardIcons ? 'arrow-up' : 'arrow-down'}`}></span></div>
            <div className={`icon-wrapper ${toggleHardIcons ? 'hidden' : ''}`}>
              {sexIcons.hard.map((item, index) => (
                <div key={index} className="sex-icon" onClick={() => onSelectGif(item)}>{hasTriggered && <img alt="gif" src={item}/>}
                  <div className={`${shouldApplyClass(index) ? 'left' : 'right'} tooltip-text`}>{item.split('/').pop().split('.')[0].replace(/-/g, ' ')}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="sex-icon-innocent">
            <div className="sex-icon-header" onClick={iconBtnHandler}><span>Innocent</span> <span
              className={`${!toggleSoftIcons ? 'arrow-up' : 'arrow-down'}`}></span></div>
            <div className={`icon-wrapper ${toggleSoftIcons ? 'hidden' : ''}`}>
              {sexIcons.innocent.map((item, index) => (
                <div key={index} className="sex-icon" onClick={() => onSelectGif(item)}>{hasTriggered && <img alt="gif" src={item}/>}
                  <div className={`${shouldApplyClass(index) ? 'left' : 'right'} tooltip-text`}>{item.split('/').pop().split('.')[0].replace(/-/g, ' ')}</div>
                </div>
              ))}
            </div>
          </div>
          <p className={userHasSentFreeIcon ? 'hidden' : 'first-try-paragraph'}>First try it's <span>FREE!</span></p>
        </div>
      </div>
    </>
  )
}
